<template>
  <div>
    <div class="menu">
      <ul class="menu-options">
        <li @click="emitEvent('newNote')" class="menu-option">Add Note</li>
        <li @click="emitEvent('newFreehand')" class="menu-option">Add Freehand</li>
        <li @click="emitEvent('newFlashcardDeck')" class="menu-option">Add Flashcard Deck</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Popover from '@/components/widgets/popover';

  export default {
    name: 'ContextMenu',
    components: {
      Popover
    },
    methods: {
      emitEvent: function(eventToEmit) {
        this.$emit(eventToEmit);
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.menu {
  box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
  position: absolute;
  display: none;
  z-index: 599;
  background: white;

  .menu-options {
    list-style: none;
    padding: 10px 0;

    .menu-option {
      font-weight: 500;
      font-size: 14px;
      padding: 10px 40px 10px 20px;
      cursor: pointer;
      text-align: left;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
}

</style>

